export default {"src":"/_next/static/media/logo.39eeb714.svg","height":73,"width":231,"blurWidth":0,"blurHeight":0};